import React from 'react';
import {Button, Form, Modal} from "semantic-ui-react";
import {useForm} from "react-hook-form";
import {postCourseSections, putCourseSections} from "../../../../../redux/actions";

export const SectionForm = ({show, item, onCancel, onSuccess}) => {

    const {register, handleSubmit, formState} = useForm({
        defaultValues: {
            name: item.name
        }
    });

    const onSubmit = async data => {

        data.course_id = item.course_id;

        if (item.section_id) {
            data.parent_id = item.section_id;
        }

        try {
            const id = parseInt(data.id);
            if (id) {
                await putCourseSections(data);
            } else {
                await postCourseSections(data);
            }

            onSuccess();
        } catch (e) {
            alert('error')
        }
    };

    return (
        <Modal open={show} size={'tiny'}>
            <Modal.Header>{item.id ? 'Editar' : 'Criar'} {item.section_id ? 'Aula' : 'Módulo'}</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <Form id={'form'} onSubmit={handleSubmit(onSubmit)} loading={formState.isSubmitting}>
                        <input type={'hidden'} name={'id'} defaultValue={item.id || ''} ref={register()}/>
                        <Form.Field>
                            <label>Título</label>
                            <input
                                name={'title'}
                                defaultValue={item.title || ''}
                                ref={register({required: true})}
                                autoFocus
                            />
                        </Form.Field>
                    </Form>
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button basic content={'Cancelar'} onClick={onCancel}/>
                <Button
                    positive
                    content="Salvar"
                    form={'form'}
                />
            </Modal.Actions>
        </Modal>
    )
}